import i18n from '@/configs/i18n'
import { pageUrl } from '@/constants/url'
import { useScreenWidth } from '@/hooks/commons/useScreenWidth'
import {
  BellOutlined,
  PercentageOutlined,
  UnlockOutlined,
  UserOutlined,
} from '@ant-design/icons'
import { Menu, MenuProps } from 'antd'
import { Link, Outlet, useLocation } from 'react-router-dom'

interface IGenerateLink {
  label: string
  url: string
}
const MenuLink = ({ label, url }: IGenerateLink) => {
  return <Link to={url}>{label}</Link>
}

const items: MenuProps['items'] = [
  {
    label: (
      <MenuLink label={i18n.t('common.profile')} url={pageUrl.accountProfile} />
    ),
    key: pageUrl.accountProfile,
    icon: <UserOutlined />,
  },
  {
    label: (
      <MenuLink
        label={i18n.t('common.password.security')}
        url={pageUrl.accountPasswordSecurity}
      />
    ),
    key: pageUrl.accountPasswordSecurity,
    icon: <UnlockOutlined />,
  },
  {
    label: (
      <MenuLink
        label={i18n.t('common.push.notification')}
        url={pageUrl.pushNotification}
      />
    ),
    key: pageUrl.pushNotification,
    icon: <BellOutlined />,
  },
  {
    label: (
      <MenuLink
        label={i18n.t('common.my.commission')}
        url={pageUrl.myCommissions}
      />
    ),
    key: pageUrl.myCommissions,
    icon: <PercentageOutlined />,
  },
]
export const LayoutAccount = () => {
  const location = useLocation()
  const { isMobile } = useScreenWidth()
  return (
    <div className="flex flex-col justify-center gap-4 md:flex-row">
      <div>
        <Menu
          className="rounded"
          items={items}
          selectedKeys={[location.pathname]}
          mode={isMobile ? 'horizontal' : 'inline'}
        />
      </div>
      <div className="flex-1 max-w-[900px]">
        <Outlet />
      </div>
    </div>
  )
}
